import produce from 'immer';
import { setOrder, setLastExchange, clearLastExchange, setLastRefund } from './actions';
const initialState = null;
export const orderReducer = (state = initialState, { type, payload }) => {
    return produce(state, draft => {
        switch (type) {
            case setOrder.toString():
                return payload;
            case setLastRefund.toString():
                const lastRefundActionPayload = payload;
                draft.exareInfo.lastRefund = lastRefundActionPayload;
                break;
            case setLastExchange.toString():
                const lastExchangeActionPayload = payload;
                draft.exareInfo.lastExchange = lastExchangeActionPayload;
                break;
            case clearLastExchange.toString():
                draft.exareInfo.lastExchange = null;
                break;
        }
    });
};
